import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2537a2c4 = () => interopDefault(import('../pages/apiDetails/index.vue' /* webpackChunkName: "pages/apiDetails/index" */))
const _69443fc5 = () => interopDefault(import('../pages/apiHiring/index.vue' /* webpackChunkName: "pages/apiHiring/index" */))
const _9df46e86 = () => interopDefault(import('../pages/boleto/index.vue' /* webpackChunkName: "pages/boleto/index" */))
const _07d836ea = () => interopDefault(import('../pages/boletoPdf/index.vue' /* webpackChunkName: "pages/boletoPdf/index" */))
const _3daa8cbd = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _30a6c4db = () => interopDefault(import('../pages/home/index.vue' /* webpackChunkName: "pages/home/index" */))
const _3b648071 = () => interopDefault(import('../pages/inspire.vue' /* webpackChunkName: "pages/inspire" */))
const _11e4b07a = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _39089527 = () => interopDefault(import('../pages/questions/index.vue' /* webpackChunkName: "pages/questions/index" */))
const _15fa3dc2 = () => interopDefault(import('../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _1c5a1737 = () => interopDefault(import('../pages/registerConfirm/index.vue' /* webpackChunkName: "pages/registerConfirm/index" */))
const _eda31db8 = () => interopDefault(import('../pages/resetPassword/index.vue' /* webpackChunkName: "pages/resetPassword/index" */))
const _92710a9a = () => interopDefault(import('../pages/termsPolicy/index.vue' /* webpackChunkName: "pages/termsPolicy/index" */))
const _40569fc7 = () => interopDefault(import('../pages/admin/account/index.vue' /* webpackChunkName: "pages/admin/account/index" */))
const _374e5bdc = () => interopDefault(import('../pages/admin/apiconsumed/index.vue' /* webpackChunkName: "pages/admin/apiconsumed/index" */))
const _608d1315 = () => interopDefault(import('../pages/admin/apis/index.vue' /* webpackChunkName: "pages/admin/apis/index" */))
const _637036ac = () => interopDefault(import('../pages/admin/approvals/index.vue' /* webpackChunkName: "pages/admin/approvals/index" */))
const _6a66d1a0 = () => interopDefault(import('../pages/admin/auditoria/index.vue' /* webpackChunkName: "pages/admin/auditoria/index" */))
const _38f713ba = () => interopDefault(import('../pages/admin/category/index.vue' /* webpackChunkName: "pages/admin/category/index" */))
const _a8f98f9a = () => interopDefault(import('../pages/admin/consumerConsumptionReport/index.vue' /* webpackChunkName: "pages/admin/consumerConsumptionReport/index" */))
const _758f0d09 = () => interopDefault(import('../pages/admin/consumptionReport/index.vue' /* webpackChunkName: "pages/admin/consumptionReport/index" */))
const _1223f59b = () => interopDefault(import('../pages/admin/dashboards/index.vue' /* webpackChunkName: "pages/admin/dashboards/index" */))
const _48539395 = () => interopDefault(import('../pages/admin/institutionSettings/index.vue' /* webpackChunkName: "pages/admin/institutionSettings/index" */))
const _4da03b27 = () => interopDefault(import('../pages/admin/questions/index.vue' /* webpackChunkName: "pages/admin/questions/index" */))
const _728996da = () => interopDefault(import('../pages/admin/savedApis/index.vue' /* webpackChunkName: "pages/admin/savedApis/index" */))
const _040da0b3 = () => interopDefault(import('../pages/admin/termsPolicy/index.vue' /* webpackChunkName: "pages/admin/termsPolicy/index" */))
const _2d17bca6 = () => interopDefault(import('../pages/admin/themeSettings/index.vue' /* webpackChunkName: "pages/admin/themeSettings/index" */))
const _b3731cbc = () => interopDefault(import('../pages/admin/users/index.vue' /* webpackChunkName: "pages/admin/users/index" */))
const _d1ef4808 = () => interopDefault(import('../pages/apiHiring/payment/index.vue' /* webpackChunkName: "pages/apiHiring/payment/index" */))
const _622f52ee = () => interopDefault(import('../pages/apiHiring/plan/index.vue' /* webpackChunkName: "pages/apiHiring/plan/index" */))
const _84a6a834 = () => interopDefault(import('../pages/admin/apis/new/index.vue' /* webpackChunkName: "pages/admin/apis/new/index" */))
const _0c05446d = () => interopDefault(import('../pages/admin/users/edit/index.vue' /* webpackChunkName: "pages/admin/users/edit/index" */))
const _996c081a = () => interopDefault(import('../pages/admin/users/new/index.vue' /* webpackChunkName: "pages/admin/users/new/index" */))
const _6cdf61a2 = () => interopDefault(import('../pages/admin/apis/keys/_id/index.vue' /* webpackChunkName: "pages/admin/apis/keys/_id/index" */))
const _659e28c7 = () => interopDefault(import('../pages/admin/apiconsumed/_id/index.vue' /* webpackChunkName: "pages/admin/apiconsumed/_id/index" */))
const _5466c900 = () => interopDefault(import('../pages/admin/apis/_id/index.vue' /* webpackChunkName: "pages/admin/apis/_id/index" */))
const _1e39bbaf = () => interopDefault(import('../pages/apiDetails/_id/index.vue' /* webpackChunkName: "pages/apiDetails/_id/index" */))
const _20bdf030 = () => interopDefault(import('../pages/apiHiring/_id/index.vue' /* webpackChunkName: "pages/apiHiring/_id/index" */))
const _4a9742da = () => interopDefault(import('../pages/home/_search/index.vue' /* webpackChunkName: "pages/home/_search/index" */))
const _119300e0 = () => interopDefault(import('../pages/home/_search/_text/index.vue' /* webpackChunkName: "pages/home/_search/_text/index" */))
const _645b6e29 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/apiDetails",
    component: _2537a2c4,
    name: "apiDetails"
  }, {
    path: "/apiHiring",
    component: _69443fc5,
    name: "apiHiring"
  }, {
    path: "/boleto",
    component: _9df46e86,
    name: "boleto"
  }, {
    path: "/boletoPdf",
    component: _07d836ea,
    name: "boletoPdf"
  }, {
    path: "/help",
    component: _3daa8cbd,
    name: "help"
  }, {
    path: "/home",
    component: _30a6c4db,
    name: "home"
  }, {
    path: "/inspire",
    component: _3b648071,
    name: "inspire"
  }, {
    path: "/login",
    component: _11e4b07a,
    name: "login"
  }, {
    path: "/questions",
    component: _39089527,
    name: "questions"
  }, {
    path: "/register",
    component: _15fa3dc2,
    name: "register"
  }, {
    path: "/registerConfirm",
    component: _1c5a1737,
    name: "registerConfirm"
  }, {
    path: "/resetPassword",
    component: _eda31db8,
    name: "resetPassword"
  }, {
    path: "/termsPolicy",
    component: _92710a9a,
    name: "termsPolicy"
  }, {
    path: "/admin/account",
    component: _40569fc7,
    name: "admin-account"
  }, {
    path: "/admin/apiconsumed",
    component: _374e5bdc,
    name: "admin-apiconsumed"
  }, {
    path: "/admin/apis",
    component: _608d1315,
    name: "admin-apis"
  }, {
    path: "/admin/approvals",
    component: _637036ac,
    name: "admin-approvals"
  }, {
    path: "/admin/auditoria",
    component: _6a66d1a0,
    name: "admin-auditoria"
  }, {
    path: "/admin/category",
    component: _38f713ba,
    name: "admin-category"
  }, {
    path: "/admin/consumerConsumptionReport",
    component: _a8f98f9a,
    name: "admin-consumerConsumptionReport"
  }, {
    path: "/admin/consumptionReport",
    component: _758f0d09,
    name: "admin-consumptionReport"
  }, {
    path: "/admin/dashboards",
    component: _1223f59b,
    name: "admin-dashboards"
  }, {
    path: "/admin/institutionSettings",
    component: _48539395,
    name: "admin-institutionSettings"
  }, {
    path: "/admin/questions",
    component: _4da03b27,
    name: "admin-questions"
  }, {
    path: "/admin/savedApis",
    component: _728996da,
    name: "admin-savedApis"
  }, {
    path: "/admin/termsPolicy",
    component: _040da0b3,
    name: "admin-termsPolicy"
  }, {
    path: "/admin/themeSettings",
    component: _2d17bca6,
    name: "admin-themeSettings"
  }, {
    path: "/admin/users",
    component: _b3731cbc,
    name: "admin-users"
  }, {
    path: "/apiHiring/payment",
    component: _d1ef4808,
    name: "apiHiring-payment"
  }, {
    path: "/apiHiring/plan",
    component: _622f52ee,
    name: "apiHiring-plan"
  }, {
    path: "/admin/apis/new",
    component: _84a6a834,
    name: "admin-apis-new"
  }, {
    path: "/admin/users/edit",
    component: _0c05446d,
    name: "admin-users-edit"
  }, {
    path: "/admin/users/new",
    component: _996c081a,
    name: "admin-users-new"
  }, {
    path: "/admin/apis/keys/:id",
    component: _6cdf61a2,
    name: "admin-apis-keys-id"
  }, {
    path: "/admin/apiconsumed/:id",
    component: _659e28c7,
    name: "admin-apiconsumed-id"
  }, {
    path: "/admin/apis/:id",
    component: _5466c900,
    name: "admin-apis-id"
  }, {
    path: "/apiDetails/:id",
    component: _1e39bbaf,
    name: "apiDetails-id"
  }, {
    path: "/apiHiring/:id",
    component: _20bdf030,
    name: "apiHiring-id"
  }, {
    path: "/home/:search",
    component: _4a9742da,
    name: "home-search"
  }, {
    path: "/home/:search/:text",
    component: _119300e0,
    name: "home-search-text"
  }, {
    path: "/",
    component: _645b6e29,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
